import { Component, ViewChild, ElementRef, Input } from '@angular/core';
import { ViewController, NavParams, Events } from 'ionic-angular';

// Providers 
import { InstructorsService } from '../../providers/instructors/instructors-service';
import { HelperService } from '../../providers/helpers/helper-service';

@Component({
  templateUrl: 'education.modal.html'
})

export class EducationModalPage
{
  edit: boolean = false;
  modalTitle: string = 'New Continuing Education';
  education: any = {};
  instructors: any = [];
  dateRange: any = {};
  bulkSave: boolean = false;

  constructor(
    public viewCtrl: ViewController,
    public navParams: NavParams,
    public instructorsService: InstructorsService,
    public helperService: HelperService,
    public events: Events
  ) {
    this.dateRange = this.helperService.getYearRange();
    this.instructors = this.navParams.get('instructors');
    if ( this.navParams.get('edit') === true )
    {
      this.edit = true;
      this.modalTitle = 'Edit Continuing Education';
      this.education = this.navParams.get('editData');
    }
  }

  saveEducation()
  {
    this.education.number_hours = +this.education.number_hours;
    this.instructorsService.saveEducation( this.instructors, this.education )
      .subscribe( data => {
        let educations:any = data;
        for ( let instructor of this.instructors )
        {
          for ( let ed of educations )
          {
            if ( ed.instructor_id === instructor.instructor_id )
            {
              instructor.education.push( ed );
            }
          }
        }
        this.events.publish('app:log', {
          message: 'Instructor continuing education entry saved.',
          status: 'success',
          type: 'save instructor education'
        });
    },
    error => {
      this.helperService.showErrors( error );
    });

    this.dismissModal();
  }

  dismissModal() {
    this.viewCtrl.dismiss();
  }
}



// WEBPACK FOOTER //
// ./src/components/modals/education.modal.ts